/*
 * ToC (Table of Content)
 *
 */
class Toc {
  constructor() {
    this.num = 1;
    this.opened = 0;
    this.writeOut = '';
    this.previous = 0;
    this.parentOb = null;
  }

  setup(tocTargetId) {
    this.parentOb = document.getElementById('toc');

    if(this.parentOb) {
      if(typeof tocGen === "undefined") {
        if(typeof tocTargetId === "undefined") {
          const mainContent = document.getElementById("vrtx-main-content");
          if(mainContent) {
            tocTargetId = "vrtx-main-content";
          } else {
            tocTargetId = "main";
          }
        }
        document.addEventListener("DOMContentLoaded", (e) => {
          this.tocGen(tocTargetId);
          this.forceScrollToTocIdIfNotScrolled();
        });
      // if old JS is not removed yet
      } else {
        if(typeof tocTargetId === "undefined") {
          const mainContent = document.getElementById("vrtx-main-content");
          if(mainContent) {
            window.tocTargetId = "vrtx-main-content";
          } else {
            window.tocTargetId = "main";
          }
        } else {
          window.tocTargetId = tocTargetId;
        }
      }
    }
  }

  tocGen(tocTargetId) {
    var headers = null;
    if (tocTargetId !== "") {
      var tocTarget = document.getElementById(tocTargetId);
      if(tocTarget != null) {
        headers = tocTarget.querySelectorAll('h2,h3');
      } else {
        headers = document.querySelectorAll('h2,h3');
      }
    } else {
      headers = document.querySelectorAll('h2,h3');
    }
    if (headers !== null && headers.length > 0) {
      var headerNr = null;
      for (var i = 0; i < headers.length; i++) {
        if ('vrtx-toc-header' == headers[i].className) {
          continue;
        }
        headerNr = headers[i].nodeName.substring(1)
        if (headerNr > this.previous) {
          this.writeOut += '<ul>';

          this.opened++;
          this.addLink(headers[i]);
        } else if (headerNr < this.previous) {
          var headerChange = this.previous - headerNr;
          while (headerChange--) {
            this.writeOut += '<\/li><\/ul>';
            this.opened--;
          }
          this.addLink(headers[i]);
        } else {
          this.writeout += '<\/li>';
          this.addLink(headers[i]);
        }
        this.previous = headerNr;
      }
      while (this.opened--) { // close all opened
        this.writeOut += '<\/li><\/ul>';
      }
      this.parentOb.innerHTML = this.writeOut;
    }
  }

  addLink(ob) {
    var linkInside = ob.firstChild;
    if(linkInside && linkInside.nodeName === "A") {
      ob = linkInside;
    }
    var id = this.getId(ob);
    var link = '<li><a href="#' + id + '">' + ob.innerHTML + '<\/a>';
    this.writeOut += link;
  }

  getId(ob) {
    if (!ob.id) {
      ob.id = 'toc' + this.num;
      this.num++;
    }
    return ob.id;
  }

  forceScrollToTocIdIfNotScrolled() {
    try {
      var doc = document.documentElement;
      var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
      if(top === 0 && window.location.hash && /#toc[\d]{1}/.test(window.location.hash)) {
        // Force scroll after toc is generated if not already has scrolled
        var elm = document.getElementById(window.location.hash.split("#")[1]);
        elm.scrollIntoView();
      }
    } catch(e) {}
  }
}
export default new Toc;